import svgUrl from '@images/move-marker.svg'
import { Box } from '@mui/material'
import { CSSProperties } from 'react'

interface iconProps {
  id?: string
  sx?: CSSProperties
}

const MoveMarkerIcon = (props: iconProps) => {
  return (
    <Box style={{ height: 20, width: 20, ...props.sx }}>
      <img
        src={svgUrl}
        alt="move-marker-icon"
        style={{ height: 'inherit', width: 'inherit' }}
        id={props.id}
      />
    </Box>
  )
}

export default MoveMarkerIcon
